(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dhl-delivery-info"] && !Shopify.designMode) return;
  try {
    (function () {
    var CARRIERS = {
      GB: { svg: '<svg viewBox="0 0 80 20" xmlns="http://www.w3.org/2000/svg" width="72" height="20"><rect width="80" height="20" rx="3" fill="#E11B22"/><text x="50%" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="9.5" fill="#fff" letter-spacing="0.3">ROYAL MAIL</text></svg>' },
      AU: { svg: '<svg viewBox="0 0 90 20" xmlns="http://www.w3.org/2000/svg" width="82" height="20"><rect width="90" height="20" rx="3" fill="#DC1928"/><text x="50%" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="8.5" fill="#fff" letter-spacing="0.3">AUSTRALIA POST</text></svg>' },
      US: { svg: '<svg viewBox="0 0 60 20" xmlns="http://www.w3.org/2000/svg" width="52" height="20"><rect width="60" height="20" rx="3" fill="#4D148C"/><text x="28" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="11" fill="#FF6200" letter-spacing="0.5">Fed</text><text x="46" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="11" fill="#fff" letter-spacing="0.5">Ex</text></svg>' },
      CA: { svg: '<svg viewBox="0 0 90 20" xmlns="http://www.w3.org/2000/svg" width="82" height="20"><rect width="90" height="20" rx="3" fill="#CC0000"/><text x="50%" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="8.5" fill="#fff" letter-spacing="0.3">CANADA POST</text></svg>' },
      SE: { svg: '<svg viewBox="0 0 70 20" xmlns="http://www.w3.org/2000/svg" width="62" height="20"><rect width="70" height="20" rx="3" fill="#004F9F"/><text x="50%" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="10" fill="#F4C300" letter-spacing="0.3">PostNord</text></svg>' },
      NO: { svg: '<svg viewBox="0 0 80 20" xmlns="http://www.w3.org/2000/svg" width="72" height="20"><rect width="80" height="20" rx="3" fill="#EF3340"/><text x="50%" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="9" fill="#fff" letter-spacing="0.3">POSTEN NORGE</text></svg>' },
      SG: { svg: '<svg viewBox="0 0 70 20" xmlns="http://www.w3.org/2000/svg" width="62" height="20"><rect width="70" height="20" rx="3" fill="#EE1C25"/><text x="50%" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="10" fill="#fff" letter-spacing="0.3">SingPost</text></svg>' },
      AE: { svg: '<svg viewBox="0 0 90 20" xmlns="http://www.w3.org/2000/svg" width="82" height="20"><rect width="90" height="20" rx="3" fill="#006233"/><text x="50%" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="8.5" fill="#fff" letter-spacing="0.3">EMIRATES POST</text></svg>' },
      DK: { svg: '<svg viewBox="0 0 70 20" xmlns="http://www.w3.org/2000/svg" width="62" height="20"><rect width="70" height="20" rx="3" fill="#004F9F"/><text x="50%" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="10" fill="#F4C300" letter-spacing="0.3">PostNord</text></svg>' },
      NL: { svg: '<svg viewBox="0 0 60 20" xmlns="http://www.w3.org/2000/svg" width="52" height="20"><rect width="60" height="20" rx="3" fill="#FF6600"/><text x="50%" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="11" fill="#fff" letter-spacing="0.5">PostNL</text></svg>' },
      DEFAULT: { svg: '<svg viewBox="0 0 60 20" xmlns="http://www.w3.org/2000/svg" width="52" height="18"><rect width="60" height="20" rx="3" fill="#FFCC00"/><text x="50%" y="14" text-anchor="middle" font-family="Arial" font-weight="900" font-size="11" fill="#D40511" letter-spacing="1">DHL</text></svg>' }
    };

    var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    var countryPromise = null;

    function fetchJson(url) {
      var opts = {};
      try { if (window.AbortSignal && AbortSignal.timeout) opts.signal = AbortSignal.timeout(3000); } catch (e) {}
      return fetch(url, opts).then(function (r) { return r.json(); });
    }

    function detectCountry() {
      if (countryPromise) return countryPromise;
      countryPromise = new Promise(function (resolve) {
        try {
          var sc = (window.Shopify && window.Shopify.country)
            ? window.Shopify.country
            : (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.country
                ? window.ShopifyAnalytics.meta.country
                : null);
          if (sc) { resolve(sc); return; }
        } catch (e) {}

        fetchJson('https://ipapi.co/json/')
          .then(function (d) {
            if (d && d.country_code) { resolve(d.country_code); return; }
            throw new Error('no code');
          })
          .catch(function () {
            fetchJson('http://ip-api.com/json/?fields=countryCode')
              .then(function (d) {
                if (d && d.countryCode) { resolve(d.countryCode); return; }
                throw new Error('no code');
              })
              .catch(function () {
                fetchJson('https://ipwho.is/')
                  .then(function (d) {
                    if (d && d.country_code) { resolve(d.country_code); return; }
                    throw new Error('no code');
                  })
                  .catch(function () { resolve('DEFAULT'); });
              });
          });
      });
      return countryPromise;
    }

    function initOne(root) {
      if (root.dataset.shipInit) return;
      root.dataset.shipInit = '1';

      var deliveryDays = parseInt(root.getAttribute('data-delivery-days'), 10) || 3;
      var minV = parseInt(root.getAttribute('data-min-viewers'), 10) || 18;
      var maxV = parseInt(root.getAttribute('data-max-viewers'), 10) || 32;
      if (maxV < minV) { var tmp = maxV; maxV = minV; minV = tmp; }

      var logoEl = root.querySelector('[data-ship-logo]');
      if (logoEl) {
        logoEl.innerHTML = CARRIERS.DEFAULT.svg;
        detectCountry().then(function (code) {
          var carrier = CARRIERS[code] || CARRIERS.DEFAULT;
          logoEl.innerHTML = carrier.svg;
        });
      }

      var dateEl = root.querySelector('[data-ship-date]');
      if (dateEl) {
        var d = new Date();
        d.setDate(d.getDate() + deliveryDays);
        dateEl.textContent = WEEKDAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
      }

      var countEl = root.querySelector('[data-ship-count]');
      if (!countEl) return;
      var current = Math.floor(Math.random() * (maxV - minV + 1)) + minV;
      countEl.textContent = current;

      function tick() {
        var delay = Math.floor(Math.random() * 8000) + 4000;
        setTimeout(function () {
          var goUp = Math.random() < 0.6;
          var change = Math.floor(Math.random() * 3) + 1;
          current = goUp ? Math.min(current + change, maxV) : Math.max(current - change, minV);
          countEl.style.transition = 'opacity 0.3s ease';
          countEl.style.opacity = '0';
          setTimeout(function () {
            countEl.textContent = current;
            countEl.style.opacity = '1';
          }, 300);
          tick();
        }, delay);
      }
      tick();
    }

    function initAll() {
      document.querySelectorAll('[data-ship-bar]').forEach(initOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:block:load', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
